import React, { memo } from 'react'
import { Tooltip } from '@mantine/core'
import { IconHelp } from '@tabler/icons'

const Tips = ({ size = 18, label }) => {
  return (
    <Tooltip label={label} placement="start" withArrow>
      <IconHelp className="cursor-help" size={size} />
    </Tooltip>
  )
}

export default memo(Tips)
